/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {ContactDto} from "./contactDto.zod";
import {NoteDto} from "./noteDto.zod";
import {RegisteredCompanyDto} from "./registeredCompanyDto.zod";
import {SupplierFunctionId} from "./supplierFunctionId.zod";
import {SupplierId} from "./supplierId.zod";
import {SupplierRole} from "./supplierRole.zod";
import {SupplierStandardization} from "./supplierStandardization.zod";
import {SupplierState} from "./supplierState.zod";
import {SupplierStatus} from "./supplierStatus.zod";

export const supplierDtoDeliveryTimeDaysMin = 0;

export const supplierDtoPaymentTimeDaysMin = 0;

export const SupplierDto = zod.object({
  supplierId: SupplierId,
  state: SupplierState,
  createdAt: zod.iso.datetime({offset: true}),
  updatedAt: zod.iso.datetime({offset: true}),
  deletedAt: zod.iso.datetime({offset: true}).nullable(),
  company: RegisteredCompanyDto,
  logoUrl: zod.string().nullable(),
  status: SupplierStatus,
  roles: zod.array(SupplierRole).min(1),
  standardization: SupplierStandardization,
  deliveryTimeDays: zod.int().min(supplierDtoDeliveryTimeDaysMin),
  paymentTimeDays: zod.int().min(supplierDtoPaymentTimeDaysMin),
  functionIds: zod.array(SupplierFunctionId),
  usable: zod.boolean(),
  contacts: zod.array(ContactDto),
  notes: zod.array(NoteDto),
});

export type SupplierDto = zod.input<typeof SupplierDto>;
export type SupplierDtoOutput = zod.output<typeof SupplierDto>;
